import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import "./index.scss";

const Pagination = ({
  skip = 0,
  limit = 10,
  total = 0,
  onPageChange = () => {},
}) => {
  const currentPage = Math.floor(skip / limit);
  const totalPages = Math.ceil(total / limit);

  const handlePrev = () => {
    if (currentPage > 0) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) onPageChange(currentPage + 1);
  };

  const start = skip + 1;
  const end = Math.min((currentPage + 1) * limit, total);

  return (
    <div className="d-flex justify-content-end align-items-center px-3 custom-pagination">
      <span className="pagination-info">
        {start}-{end} <span className="ofTotal">of {total}</span>
      </span>
      <span className="pagination-button">
        <button
          className="page-arrow"
          onClick={handlePrev}
          disabled={currentPage === 0}
        >
          <FaAngleLeft size={16} />
        </button>
        <button
          className="page-arrow"
          onClick={handleNext}
          disabled={currentPage >= totalPages - 1}
        >
          <FaAngleRight size={16} />
        </button>
      </span>
    </div>
  );
};

export default Pagination;
